import { AAGUID, EncodedHttpParams } from '@interticket/core';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IEventsSource } from '../../interfaces/event/events-source.interface';
import { IEventView } from '../../interfaces/event/event-view.interface';
import { EventFilter } from '../../models/event/event-filter.model';
import { IEventListItem } from '../../interfaces/event/event-list-item.interface';
import { IEventViewBase } from '@core/interfaces/event/event-view-base.interface';
import { HttpService } from '@interticket/core';

@Injectable()
export class EventsSourceService implements IEventsSource {

  private readonly serviceVersion: string = environment.modules.core.event.version;
  private readonly serviceBaseUrl: string = `/${this.serviceVersion}/productcatalog/web`;

  constructor(
    private httpService: HttpService
  ) { }

  getEvent(eventId: AAGUID): Observable<IEventView> {
    return this.httpService.get<IEventView>(`${this.serviceBaseUrl}/${eventId}`);
  }

  getList(searchParams?: SearchParams, filter?: EventFilter): Observable<IListResult<IEventListItem>> {
    let params: HttpParams = searchParams ? searchParams.getHttpParams() : new EncodedHttpParams();
    if (filter) {
      params = filter.getHttpParams(params);
    }
    return this.httpService.get<IListResult<IEventListItem>>(`${this.serviceBaseUrl}/event`, { params });
  }

  getMoreEvents(id: AAGUID): Observable<IListResult<IEventViewBase>> {
    return this.httpService.get<IListResult<IEventViewBase>>(`${this.serviceBaseUrl}/program/${id}/event`);
  }

  getListByIds(eventIds: AAGUID[]): Observable<IEventView[]> {
    let params: HttpParams = new EncodedHttpParams();
    eventIds.forEach((id: AAGUID) => {
      params = params.append('ids', id);
    });
    return this.httpService.get<IEventView[]>(`${this.serviceBaseUrl}/event/bulk`, { params });
  }

  getCalendarEvents(): Observable<IListResult<IEventViewBase>> {
    return this.httpService.get<IListResult<IEventViewBase>>(`${this.serviceBaseUrl}/event/calendar`);
  }

}
